import React from 'react';
import { colors } from '../utils/colors';
import type { ActiveTab } from '../utils/types';

interface Props {
  activeTab: ActiveTab;
  onNavigate: (tab: ActiveTab) => void;
}

const NAV_TABS: {
  label: string;
  tab: ActiveTab;
  icon: (stroke: string) => React.ReactNode;
}[] = [
  {
    label: 'Home',
    tab: 'home',
    icon: (c) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3"  y="3"  width="7" height="7" rx="1"/>
        <rect x="14" y="3"  width="7" height="7" rx="1"/>
        <rect x="3"  y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
  {
    label: 'Insights',
    tab: 'insights',
    icon: (c) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6"  y1="20" x2="6"  y2="14"/>
      </svg>
    ),
  },
  {
    label: 'Profile',
    tab: 'profile',
    icon: (c) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  },
];

const BottomNav: React.FC<Props> = ({ activeTab, onNavigate }) => (
  <div style={{
    position: 'fixed', left: 0, right: 0, bottom: 0,
    background: '#fff',
    borderTop: `1px solid ${colors.borderLight}`,
    display: 'flex',
    justifyContent: 'space-around',
    padding: '10px 0 24px',
    zIndex: 100,
  }}>
    {NAV_TABS.map(({ label, tab, icon }) => {
      const isActive = activeTab === tab;
      const c = isActive ? colors.primary : colors.textLight;
      return (
        <button
          key={tab}
          onClick={() => onNavigate(tab)}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
            background: 'none', border: 'none', cursor: 'pointer', padding: '0 24px',
          }}
        >
          {icon(c)}
          <span style={{ fontSize: 11, fontWeight: 600, color: c }}>{label}</span>
        </button>
      );
    })}
  </div>
);

export default BottomNav;